import React, { useState, useEffect } from "react";
import LabelText from "../ui/LabelText";
import PrimaryButton from "../ui/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import IApiResponse from "../types/IApiResponse";
import apiUrls from "../config/apiUrls";
import { fetchData } from "../services/api";
import handleApiResponse from "../utils/handleApiResponse";
import MFLoginLogo from "../assets/images/MF_logo.png";
import { useLoading } from "../contexts/LoadingContext";
import LoadingSpinner from "../ui/LoadingSpinner";

const VerifyEmail = () => {
 
  const navigate = useNavigate();
  const { startLoading, stopLoading, loading } = useLoading();
  const { signupSuccess } = useAuth();
  const [verifyEmail, setIsVerifyEmail] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>("");

  const testParams = window.location.search;
  useEffect(() => {
    const VerifyEmail = async () => {
      startLoading();
      try {
        const response: IApiResponse<any> = await fetchData(
          `${apiUrls["VerifyEmail"]}${testParams}`
        );
        handleApiResponse(
          response,
          (responseData) => {
            stopLoading();
            if (response.isSuccess) {
              setIsVerifyEmail(true);
            } else {
              setIsVerifyEmail(false);
              // setErrorMsg(responseData.error?.message || 'Verification failed.');
            }
          },
          (error) => {
            stopLoading();
            setErrorMsg(response.error?.message);
          }
        );
      } catch (error) {
        stopLoading();
        console.error("Error during Verify email:", error);
        // setErrorMsg('Something went wrong while verifying the email.');
      }
    };

    if(testParams !== ""){
      VerifyEmail();
    }
  }, [testParams]);

  return (
    <>
      <div className="login-wrapper">
        <div
          className="login-container"
          style={{ padding: "30px", alignItems: "stretch", width:"550px" }}
        >
          <div className="logo center">
            <img src={MFLoginLogo} alt="mc-football-logo" />
          </div>
          <div className="signup-success-conatiner">
            {verifyEmail ? (
              <>
                <LabelText
                  className="player-family-name"
                  style={{ color: "#54E0C5", textAlign:'center' }}
                >
                  Email verification successful!
                </LabelText>
                <LabelText>
                  Thank you for verifying your email address. An administrator will now review your account.
                </LabelText>
                <LabelText>
                  You’ll receive a notification once approval is complete and login is enabled.
                </LabelText>
                <LabelText>For any sign-up or login issues, please contact our support team at
                       &nbsp;<a href="mailto:hello@machinefootball.com" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{textDecoration:'underline',color:'#54E0C5'}}
                    >hello@machinefootball.com</a>
                </LabelText>
                {/* <LabelText>
                  Please{" "}
                  <a
                    style={{ textDecoration: "underline", color: "black" }}
                    onClick={() => navigate("/login")}
                  >
                    Log in
                  </a>{" "}
                  to access your account.
                </LabelText>
                <PrimaryButton
                  className="login-button"
                  label="Log in"
                  onClick={() => navigate("/login")}
                /> */}
              </>
             ) : errorMsg ? (
              <LabelText className="error-text" style={{ color: "red" }}>
                {errorMsg}
              </LabelText>
            ) : (
              !testParams && (
                <LabelText className="error-text" style={{ color: "red" }}>
                  Some error occurred. Please try again later!
                </LabelText>
              )
            )}
          </div>
        </div>
      </div>
      {loading && <LoadingSpinner />}
    </>
  );
};

export default VerifyEmail;
